import { render, staticRenderFns } from "./ModalCreateProjectFromPresale.vue?vue&type=template&id=4735c002"
import script from "./ModalCreateProjectFromPresale.vue?vue&type=script&lang=js"
export * from "./ModalCreateProjectFromPresale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports